// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created () {
    this.setViewport()
  },
  methods: {
    setViewport: function () {
      let size = 767
      let text = 'width=device-width,initial-scale=1.0'
      if (window.innerWidth < size) {
        text = 'target-densitydpi=device-dpi, width=1024, initial-scale=0, user-scalable=yes'
      }
      document.querySelector('meta[name="viewport"]').setAttribute('content', text)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js